export default "__VITE_ASSET__WUyMeGS3__"